import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { breakpointDown, breakpointUp } from '../utils/breakpoints'

gsap.registerPlugin(ScrollTrigger)


let body = $('body')

function initCategoriesSequence() {

  if(breakpointDown('lg')) return false

  let locoScroller = breakpointUp('lg') ? '.smooth-scroll' : null

  gsap.set('.category-list-container', { skew: 0 })

  let spinTimeline = gsap.timeline({
    force3D: false,
    immediateRender: true,
    scrollTrigger: {
      trigger: "#categories-sequence",
      scroller: locoScroller,
      pin: true,
      start: "top top",
      end: "+=200%",
      scrub: 1,
      //markers: true,
    },
    ease: "none"

  })

  let categoryListHeight = $('.category-main').height() + $('.categories-all').height()
  let screenOffset = $(window).height() * 0.6
  let toY = -(categoryListHeight - screenOffset)

  spinTimeline.fromTo('.category-list', { y: 0 }, { y: toY, duration: 70 * 3, ease: "none" }, 3)
  spinTimeline.fromTo('#categories-background', { opacity: 1}, { opacity: 0, duration: 30 }, 18)

}

body.on('mouseenter', '.categories-all .category-name-header', function (e){
  $('.categories-all').addClass('hovered')
  $(this).parent().addClass('hovered')
})

body.on('mouseleave', '.categories-all .category-name-header', function (e){
  $('.categories-all').removeClass('hovered')
  $(this).parent().removeClass('hovered')
})

export { initCategoriesSequence }
